import { createReducer, createSetter } from "@/redux/helpers/reducer";

import { DEFAULT_EMAIL_MESSAGE } from "./constants";
import * as actions from "./email-invoice-card.actions";

const initialState = {
  isEmailEnabled: false,
  emailMessage: DEFAULT_EMAIL_MESSAGE,
  searchQuery: "",
  contacts: [],
  selectedContactUids: [],
  isContactModalOpen: false,
  isFetchingContacts: false,
  editingContactUid: null,
};

export default createReducer(initialState, {
  [actions.setIsEmailEnabled]: createSetter("isEmailEnabled"),
  [actions.setEmailMessage]: createSetter("emailMessage"),
  [actions.setSearchQuery]: createSetter("searchQuery"),
  [actions.setContacts]: createSetter("contacts"),
  [actions.setSelectedContactUids]: createSetter("selectedContactUids"),
  [actions.setIsContactModalOpen]: createSetter("isContactModalOpen"),
  [actions.setIsFetchingContacts]: createSetter("isFetchingContacts"),
  [actions.setEditingContactUid]: createSetter("editingContactUid"),
  [actions.reset]: () => ({ ...initialState }),
});
